/* js/pages/ConstellationPage.svelte generated by Svelte v3.46.4 */
import {
	HtmlTag,
	SvelteComponent,
	add_flush_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { db } from '../Db';
import { onMount, onDestroy } from 'svelte';
import { appRouter } from '../appRouter.js';
import Header from '../components/Header.svelte';
import MapLibre from '../components/MapLibre.svelte';
import ParcoursPath from '../components/ParcoursPath.svelte';
import UserMarkerLibre from '../components/UserMarkerLibre.svelte';

// import SpotMarkerLibre from '../components/SpotMarkerLibre.svelte';
import SimpleMarkerLibre from '../components/SimpleMarkerLibre.svelte';

import ShareButton from '../components/ShareButton.svelte';
import computeUrl from '../url';
import { Button, Ripple } from 'svelte-mui';
import HyperButton from '../components/HyperButton.svelte';
import MenuModal from '../components/MenuModal.svelte';
import * as animateScroll from "svelte-scrollto";
import GeoLocationStartButton from '../components/GeoLocationStartButton.svelte';

import {
	geoLocationManager,
	GeolocationEventType,
	GeoLocationServiceState
} from '../GeoLocationManager';

import {
	computeBounds,
	getBbox,
	lineFeatureCollectionFromPoints
} from '../geoUtils';

import { flyToProvider } from '../providers';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[22] = list[i];
	child_ctx[24] = i;
	return child_ctx;
}

// (143:0) {#if constellation}
function create_if_block_3(ctx) {
	let h1;
	let t0_value = /*constellation*/ ctx[0].title + "";
	let t0;
	let t1;
	let img;
	let img_src_value;
	let t2;
	let html_tag;
	let raw_value = /*constellation*/ ctx[0].html + "";
	let t3;
	let hyperbutton;
	let t4;
	let br0;
	let br1;
	let t5;
	let div;
	let maplibre;
	let t6;
	let t7;
	let t8;
	let if_block2_anchor;
	let current;

	hyperbutton = new HyperButton({
			props: {
				class: "button",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	hyperbutton.$on("click", /*onStart*/ ctx[4]);

	maplibre = new MapLibre({
			props: {
				onLoad: /*onMapLoaded*/ ctx[5],
				interactive: false,
				pitch: "0",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	let if_block0 = /*constellation*/ ctx[0].events_html && create_if_block_6(ctx);
	let if_block1 = /*constellation*/ ctx[0].bonus_html && create_if_block_5(ctx);
	let if_block2 = /*constellation*/ ctx[0].bibliography_html && create_if_block_4(ctx);

	return {
		c() {
			h1 = element("h1");
			t0 = text(t0_value);
			t1 = space();
			img = element("img");
			t2 = space();
			html_tag = new HtmlTag();
			t3 = space();
			create_component(hyperbutton.$$.fragment);
			t4 = space();
			br0 = element("br");
			br1 = element("br");
			t5 = space();
			div = element("div");
			create_component(maplibre.$$.fragment);
			t6 = space();
			if (if_block0) if_block0.c();
			t7 = space();
			if (if_block1) if_block1.c();
			t8 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
			if (!src_url_equal(img.src, img_src_value = appRouter.normalizePath(/*constellation*/ ctx[0].media.coverImage))) attr(img, "src", img_src_value);
			attr(img, "alt", "cover image");
			attr(img, "class", "svelte-851efv");
			html_tag.a = t3;
			attr(div, "class", "map-container svelte-851efv");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			append(h1, t0);
			insert(target, t1, anchor);
			insert(target, img, anchor);
			insert(target, t2, anchor);
			html_tag.m(raw_value, target, anchor);
			insert(target, t3, anchor);
			mount_component(hyperbutton, target, anchor);
			insert(target, t4, anchor);
			insert(target, br0, anchor);
			insert(target, br1, anchor);
			insert(target, t5, anchor);
			insert(target, div, anchor);
			mount_component(maplibre, div, null);
			insert(target, t6, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t7, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t8, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*constellation*/ 1) && t0_value !== (t0_value = /*constellation*/ ctx[0].title + "")) set_data(t0, t0_value);

			if (!current || dirty & /*constellation*/ 1 && !src_url_equal(img.src, img_src_value = appRouter.normalizePath(/*constellation*/ ctx[0].media.coverImage))) {
				attr(img, "src", img_src_value);
			}

			if ((!current || dirty & /*constellation*/ 1) && raw_value !== (raw_value = /*constellation*/ ctx[0].html + "")) html_tag.p(raw_value);
			const hyperbutton_changes = {};

			if (dirty & /*$$scope*/ 33554432) {
				hyperbutton_changes.$$scope = { dirty, ctx };
			}

			hyperbutton.$set(hyperbutton_changes);
			const maplibre_changes = {};

			if (dirty & /*$$scope, haltePoints, mapIsReady*/ 33554442) {
				maplibre_changes.$$scope = { dirty, ctx };
			}

			maplibre.$set(maplibre_changes);

			if (/*constellation*/ ctx[0].events_html) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_6(ctx);
					if_block0.c();
					if_block0.m(t7.parentNode, t7);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*constellation*/ ctx[0].bonus_html) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_5(ctx);
					if_block1.c();
					if_block1.m(t8.parentNode, t8);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*constellation*/ ctx[0].bibliography_html) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_4(ctx);
					if_block2.c();
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(hyperbutton.$$.fragment, local);
			transition_in(maplibre.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hyperbutton.$$.fragment, local);
			transition_out(maplibre.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(img);
			if (detaching) detach(t2);
			if (detaching) html_tag.d();
			if (detaching) detach(t3);
			destroy_component(hyperbutton, detaching);
			if (detaching) detach(t4);
			if (detaching) detach(br0);
			if (detaching) detach(br1);
			if (detaching) detach(t5);
			if (detaching) detach(div);
			destroy_component(maplibre);
			if (detaching) detach(t6);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t7);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t8);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

// (155:4) <HyperButton class="button" on:click={onStart} >
function create_default_slot_7(ctx) {
	let t;

	return {
		c() {
			t = text("Commencer la visite");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (164:12) {#if mapIsReady}
function create_if_block_7(ctx) {
	let each_1_anchor;
	let current;
	let each_value = /*haltePoints*/ ctx[3];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*haltePoints, gotoHalte*/ 136) {
				each_value = /*haltePoints*/ ctx[3];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (165:16) {#each haltePoints as haltePoint, index}
function create_each_block(ctx) {
	let simplemarkerlibre;
	let current;

	function requestSelection_handler() {
		return /*requestSelection_handler*/ ctx[11](/*index*/ ctx[24]);
	}

	simplemarkerlibre = new SimpleMarkerLibre({
			props: {
				index: /*index*/ ctx[24],
				coords: /*haltePoint*/ ctx[22],
				clickable: true,
				zIndex: 10
			}
		});

	simplemarkerlibre.$on("requestSelection", requestSelection_handler);

	return {
		c() {
			create_component(simplemarkerlibre.$$.fragment);
		},
		m(target, anchor) {
			mount_component(simplemarkerlibre, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const simplemarkerlibre_changes = {};
			if (dirty & /*haltePoints*/ 8) simplemarkerlibre_changes.coords = /*haltePoint*/ ctx[22];
			simplemarkerlibre.$set(simplemarkerlibre_changes);
		},
		i(local) {
			if (current) return;
			transition_in(simplemarkerlibre.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(simplemarkerlibre.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(simplemarkerlibre, detaching);
		}
	};
}

// (161:8) <MapLibre onLoad={onMapLoaded} interactive={false} pitch=0>
function create_default_slot_6(ctx) {
	let usermarkerlibre;
	let t0;
	let geolocationstartbutton;
	let t1;
	let if_block_anchor;
	let current;
	usermarkerlibre = new UserMarkerLibre({});
	geolocationstartbutton = new GeoLocationStartButton({});
	let if_block = /*mapIsReady*/ ctx[1] && create_if_block_7(ctx);

	return {
		c() {
			create_component(usermarkerlibre.$$.fragment);
			t0 = space();
			create_component(geolocationstartbutton.$$.fragment);
			t1 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(usermarkerlibre, target, anchor);
			insert(target, t0, anchor);
			mount_component(geolocationstartbutton, target, anchor);
			insert(target, t1, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*mapIsReady*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*mapIsReady*/ 2) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_7(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(usermarkerlibre.$$.fragment, local);
			transition_in(geolocationstartbutton.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(usermarkerlibre.$$.fragment, local);
			transition_out(geolocationstartbutton.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(usermarkerlibre, detaching);
			if (detaching) detach(t0);
			destroy_component(geolocationstartbutton, detaching);
			if (detaching) detach(t1);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (179:4) {#if constellation.events_html}
function create_if_block_6(ctx) {
	let section;
	let h2;
	let t1;
	let html_tag;
	let raw_value = /*constellation*/ ctx[0].events_html + "";

	return {
		c() {
			section = element("section");
			h2 = element("h2");
			h2.textContent = "Les évenements";
			t1 = space();
			html_tag = new HtmlTag();
			html_tag.a = null;
			attr(section, "class", "section-events");
		},
		m(target, anchor) {
			insert(target, section, anchor);
			append(section, h2);
			append(section, t1);
			html_tag.m(raw_value, section);
		},
		p(ctx, dirty) {
			if (dirty & /*constellation*/ 1 && raw_value !== (raw_value = /*constellation*/ ctx[0].events_html + "")) html_tag.p(raw_value);
		},
		d(detaching) {
			if (detaching) detach(section);
		}
	};
}

// (186:4) {#if constellation.bonus_html}
function create_if_block_5(ctx) {
	let section;
	let h2;
	let t1;
	let html_tag;
	let raw_value = /*constellation*/ ctx[0].bonus_html + "";

	return {
		c() {
			section = element("section");
			h2 = element("h2");
			h2.textContent = "Les bonus";
			t1 = space();
			html_tag = new HtmlTag();
			html_tag.a = null;
			attr(section, "class", "section-bonus");
		},
		m(target, anchor) {
			insert(target, section, anchor);
			append(section, h2);
			append(section, t1);
			html_tag.m(raw_value, section);
		},
		p(ctx, dirty) {
			if (dirty & /*constellation*/ 1 && raw_value !== (raw_value = /*constellation*/ ctx[0].bonus_html + "")) html_tag.p(raw_value);
		},
		d(detaching) {
			if (detaching) detach(section);
		}
	};
}

// (193:4) {#if constellation.bibliography_html}
function create_if_block_4(ctx) {
	let section;
	let h2;
	let t1;
	let html_tag;
	let raw_value = /*constellation*/ ctx[0].bibliography_html + "";

	return {
		c() {
			section = element("section");
			h2 = element("h2");
			h2.textContent = "Bibliographie";
			t1 = space();
			html_tag = new HtmlTag();
			html_tag.a = null;
			attr(section, "class", "section-bibliography");
		},
		m(target, anchor) {
			insert(target, section, anchor);
			append(section, h2);
			append(section, t1);
			html_tag.m(raw_value, section);
		},
		p(ctx, dirty) {
			if (dirty & /*constellation*/ 1 && raw_value !== (raw_value = /*constellation*/ ctx[0].bibliography_html + "")) html_tag.p(raw_value);
		},
		d(detaching) {
			if (detaching) detach(section);
		}
	};
}

// (204:8) <Button on:click={() => gotoSection('.section-map')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_5(ctx) {
	let t;

	return {
		c() {
			t = text("carte");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (207:8) <Button on:click={() => gotoSection('.section-haltes')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_4(ctx) {
	let t;

	return {
		c() {
			t = text("Haltes");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (211:8) {#if constellation.events_html}
function create_if_block_2(ctx) {
	let button;
	let t;
	let div;
	let current;

	button = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*click_handler_4*/ ctx[14]);

	return {
		c() {
			create_component(button.$$.fragment);
			t = space();
			div = element("div");
			attr(div, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty & /*$$scope*/ 33554432) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

// (212:12) <Button on:click={() => gotoSection('.section-events')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = text("événements");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (216:8) {#if constellation.bonus_html}
function create_if_block_1(ctx) {
	let button;
	let t;
	let div;
	let current;

	button = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*click_handler_5*/ ctx[15]);

	return {
		c() {
			create_component(button.$$.fragment);
			t = space();
			div = element("div");
			attr(div, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty & /*$$scope*/ 33554432) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

// (217:12) <Button on:click={() => gotoSection('.section-bonus')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("bonus");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (221:8) {#if constellation.bibliography_html}
function create_if_block(ctx) {
	let button;
	let t;
	let div;
	let current;

	button = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*click_handler_6*/ ctx[16]);

	return {
		c() {
			create_component(button.$$.fragment);
			t = space();
			div = element("div");
			attr(div, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty & /*$$scope*/ 33554432) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

// (222:12) <Button on:click={() => gotoSection('.section-bibliography')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("bibliographie");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (202:4) <MenuModal bind:open={sectionModalVisible}>
function create_default_slot(ctx) {
	let button0;
	let t0;
	let div0;
	let t1;
	let button1;
	let t2;
	let div1;
	let t3;
	let t4;
	let t5;
	let if_block2_anchor;
	let current;

	button0 = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	button0.$on("click", /*click_handler_2*/ ctx[12]);

	button1 = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	button1.$on("click", /*click_handler_3*/ ctx[13]);
	let if_block0 = /*constellation*/ ctx[0].events_html && create_if_block_2(ctx);
	let if_block1 = /*constellation*/ ctx[0].bonus_html && create_if_block_1(ctx);
	let if_block2 = /*constellation*/ ctx[0].bibliography_html && create_if_block(ctx);

	return {
		c() {
			create_component(button0.$$.fragment);
			t0 = space();
			div0 = element("div");
			t1 = space();
			create_component(button1.$$.fragment);
			t2 = space();
			div1 = element("div");
			t3 = space();
			if (if_block0) if_block0.c();
			t4 = space();
			if (if_block1) if_block1.c();
			t5 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
			attr(div0, "class", "spacer");
			attr(div1, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button0, target, anchor);
			insert(target, t0, anchor);
			insert(target, div0, anchor);
			insert(target, t1, anchor);
			mount_component(button1, target, anchor);
			insert(target, t2, anchor);
			insert(target, div1, anchor);
			insert(target, t3, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t4, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t5, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button0_changes = {};

			if (dirty & /*$$scope*/ 33554432) {
				button0_changes.$$scope = { dirty, ctx };
			}

			button0.$set(button0_changes);
			const button1_changes = {};

			if (dirty & /*$$scope*/ 33554432) {
				button1_changes.$$scope = { dirty, ctx };
			}

			button1.$set(button1_changes);

			if (/*constellation*/ ctx[0].events_html) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*constellation*/ 1) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t4.parentNode, t4);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*constellation*/ ctx[0].bonus_html) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*constellation*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t5.parentNode, t5);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*constellation*/ ctx[0].bibliography_html) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty & /*constellation*/ 1) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(button0.$$.fragment, local);
			transition_in(button1.$$.fragment, local);
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(button0.$$.fragment, local);
			transition_out(button1.$$.fragment, local);
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			destroy_component(button0, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div0);
			if (detaching) detach(t1);
			destroy_component(button1, detaching);
			if (detaching) detach(t2);
			if (detaching) detach(div1);
			if (detaching) detach(t3);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t4);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t5);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

function create_fragment(ctx) {
	let header;
	let t0;
	let div2;
	let div0;
	let ripple0;
	let t1;
	let t2;
	let div1;
	let ripple1;
	let t3;
	let img;
	let img_src_value;
	let t4;
	let sharebutton;
	let t5;
	let div5;
	let div3;
	let t6;
	let t7;
	let menumodal;
	let updating_open;
	let t8;
	let div4;
	let current;
	let mounted;
	let dispose;
	header = new Header({ props: { title: "Constellation" } });
	ripple0 = new Ripple({ props: { center: true } });
	ripple1 = new Ripple({ props: { center: true } });
	sharebutton = new ShareButton({ props: { url: computeUrl() } });
	let if_block = /*constellation*/ ctx[0] && create_if_block_3(ctx);

	function menumodal_open_binding(value) {
		/*menumodal_open_binding*/ ctx[17](value);
	}

	let menumodal_props = {
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	if (/*sectionModalVisible*/ ctx[2] !== void 0) {
		menumodal_props.open = /*sectionModalVisible*/ ctx[2];
	}

	menumodal = new MenuModal({ props: menumodal_props });
	binding_callbacks.push(() => bind(menumodal, 'open', menumodal_open_binding));

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			div2 = element("div");
			div0 = element("div");
			create_component(ripple0.$$.fragment);
			t1 = text("EN AVOIR PLUS");
			t2 = space();
			div1 = element("div");
			create_component(ripple1.$$.fragment);
			t3 = space();
			img = element("img");
			t4 = space();
			create_component(sharebutton.$$.fragment);
			t5 = space();
			div5 = element("div");
			div3 = element("div");
			t6 = space();
			if (if_block) if_block.c();
			t7 = space();
			create_component(menumodal.$$.fragment);
			t8 = space();
			div4 = element("div");
			attr(div0, "class", "en-avoir-plus bottom-centered box-shadow");
			if (!src_url_equal(img.src, img_src_value = "/_icons/info.svg")) attr(img, "src", img_src_value);
			attr(img, "class", "svelte-851efv");
			attr(div1, "class", "fab-button small bottom-left box-shadow");
			attr(div2, "class", "footer gradient");
			attr(div3, "class", "headspacer");
			attr(div4, "class", "footerspacer");
			attr(div5, "class", "column");
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			insert(target, div2, anchor);
			append(div2, div0);
			mount_component(ripple0, div0, null);
			append(div0, t1);
			append(div2, t2);
			append(div2, div1);
			mount_component(ripple1, div1, null);
			append(div1, t3);
			append(div1, img);
			append(div2, t4);
			mount_component(sharebutton, div2, null);
			insert(target, t5, anchor);
			insert(target, div5, anchor);
			append(div5, div3);
			append(div5, t6);
			if (if_block) if_block.m(div5, null);
			append(div5, t7);
			mount_component(menumodal, div5, null);
			append(div5, t8);
			append(div5, div4);
			current = true;

			if (!mounted) {
				dispose = [
					listen(div0, "click", /*click_handler*/ ctx[9]),
					listen(div1, "click", /*click_handler_1*/ ctx[10])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*constellation*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*constellation*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div5, t7);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			const menumodal_changes = {};

			if (dirty & /*$$scope, constellation*/ 33554433) {
				menumodal_changes.$$scope = { dirty, ctx };
			}

			if (!updating_open && dirty & /*sectionModalVisible*/ 4) {
				updating_open = true;
				menumodal_changes.open = /*sectionModalVisible*/ ctx[2];
				add_flush_callback(() => updating_open = false);
			}

			menumodal.$set(menumodal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(ripple0.$$.fragment, local);
			transition_in(ripple1.$$.fragment, local);
			transition_in(sharebutton.$$.fragment, local);
			transition_in(if_block);
			transition_in(menumodal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			transition_out(ripple0.$$.fragment, local);
			transition_out(ripple1.$$.fragment, local);
			transition_out(sharebutton.$$.fragment, local);
			transition_out(if_block);
			transition_out(menumodal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div2);
			destroy_component(ripple0);
			destroy_component(ripple1);
			destroy_component(sharebutton);
			if (detaching) detach(t5);
			if (detaching) detach(div5);
			if (if_block) if_block.d();
			destroy_component(menumodal);
			mounted = false;
			run_all(dispose);
		}
	};
}

let constellationPoints = null;

function onGeoLocationStarted() {
	
}

function instance($$self, $$props, $$invalidate) {
	let { params } = $$props;
	let constellation;
	let mapIsReady = false;
	let sectionModalVisible = false;
	let userPosition = geoLocationManager.currentCoords;
	let haltePoints;

	onMount(() => {
		// console.log(params);
		$$invalidate(0, constellation = db.getConstellationWithSlug(params.slug));

		$$invalidate(3, haltePoints = db.getHalteCoordsForConstellationWithSlug(params.slug));
		console.log("mounted", params, constellation);
	});

	onDestroy(() => {
		geoLocationManager.removeEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.removeEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.removeEventListener(GeolocationEventType.stopped, onGeoLocationStopped);
	});

	function onGeoLocationUpdate(event) {
		// console.log("geo update on path page", event.value);
		userPosition = event.value;

		flyToParcoursAndUser();
	}

	function onGeoLocationStopped() {
		userPosition = null;
		flyToParcoursAndUser();
	}

	function flyToParcoursAndUser() {
		// let points = constellationPoints.slice();
		let points = haltePoints.slice();

		if (userPosition && geoLocationManager.isStarted) {
			points.push(userPosition.coords);
		}

		const bbox = getBbox(points);
		const flyToOptions = { bounds: bbox, padding: 100 };
		flyToProvider.provide(flyToOptions);
	}

	function onStart() {
		appRouter.show(`/constellation/${constellation.slug}/carte`);
	}

	async function onMapLoaded() {
		$$invalidate(1, mapIsReady = true);
		geoLocationManager.addEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.addEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.addEventListener(GeolocationEventType.stopped, onGeoLocationStopped);

		// if(constellation.media.path){
		//     parcoursPath = await db.getParcoursPath(constellation.slug);
		// }else{
		//     parcoursPath = JSON.parse(lineFeatureCollectionFromPoints(haltePoints));
		// }
		// constellationPoints = parcoursPath.features.find(feature => feature.geometry.type == "LineString").geometry.coordinates;
		flyToParcoursAndUser();
	}

	function gotoSection(query) {
		$$invalidate(2, sectionModalVisible = false);
		const offset = -100;
		animateScroll.scrollTo({ element: query, offset, duration: 700 });
	}

	function gotoHalte(halteIndex) {
		const halteSlug = constellation.steps.find(step => step.idx === halteIndex).slug;
		appRouter.show(`/constellation/${params.slug}/halte/${halteSlug}`);
	}

	const click_handler = () => $$invalidate(2, sectionModalVisible = true);
	const click_handler_1 = () => appRouter.show("/a_propos");
	const requestSelection_handler = index => gotoHalte(index);
	const click_handler_2 = () => gotoSection('.section-map');
	const click_handler_3 = () => gotoSection('.section-haltes');
	const click_handler_4 = () => gotoSection('.section-events');
	const click_handler_5 = () => gotoSection('.section-bonus');
	const click_handler_6 = () => gotoSection('.section-bibliography');

	function menumodal_open_binding(value) {
		sectionModalVisible = value;
		$$invalidate(2, sectionModalVisible);
	}

	$$self.$$set = $$props => {
		if ('params' in $$props) $$invalidate(8, params = $$props.params);
	};

	return [
		constellation,
		mapIsReady,
		sectionModalVisible,
		haltePoints,
		onStart,
		onMapLoaded,
		gotoSection,
		gotoHalte,
		params,
		click_handler,
		click_handler_1,
		requestSelection_handler,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		click_handler_5,
		click_handler_6,
		menumodal_open_binding
	];
}

class ConstellationPage extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { params: 8 });
	}
}

export default ConstellationPage;